import { create_shop_type, update_shop_type, query_shop_type_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-area-config';

import { reactive } from 'vue';
import {get_is_active, get_is_active2} from "@/utils/function";

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写名称',
    },
    {
      type: 'remoteselect',
      name: 'person_id',
      label: '负责人',
      disabled: false,
      valueKey: 'id',
      labelKey: 'realname',
      placeholder: '请选择负责人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      show_search: true,
      modalType: 'liyu_organization-person',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    person_id: null,
    person_name: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写名称',
    },
    {
      type: 'input',
      name: 'code',
      label: '板块编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写板块编号',
    },
    {
      type: 'remoteselect',
      name: 'person_id',
      label: '负责人',
      disabled: false,
      valueKey: 'id',
      labelKey: 'realname',
      placeholder: '请选择负责人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'liyu_organization-person',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入名称' }],
    code: [{ required: true, message: '请填输入板块编号' }],
    person_id: [{ required: true, message: '请填输入person_id' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    person_id: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写名称',
    },
    {
      type: 'input',
      name: 'code',
      label: '板块编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写板块编号',
    },
    {
      type: 'remoteselect',
      name: 'person_id',
      label: '负责人',
      disabled: false,
      valueKey: 'id',
      labelKey: 'realname',
      placeholder: '请选择负责人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      show_search: true,
      modalType: 'liyu_organization-person',
    },
  ],
  rules: {
    person_id: [{ required: true, message: '请填输入person_id' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
    person_id: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '板块管理',
  addModalTitle: '新建板块',
  updateTitle: '修改板块',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    shop_type_id: 'id',
  },
  delete: {
    shop_type_id: 'id',
  },
  recover: {
    shop_type_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    shop_type_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: '名称',
    dataIndex: 'name',
    checked: true,
  },
  {
    title: '板块编号',
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '负责人',
    dataIndex: 'person_name',
    checked: true,
  },
  {
    title: '负责人手机号',
    dataIndex: 'person_phone',
    checked: true,
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'action',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_shop_type_list,
    addData: create_shop_type,
    updateData: update_shop_type,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
